<header id="otb-header" class="dash-header text-white">
    <div class="navbar-header">
        <button *ngIf="loggedUser"
            [ngStyle]="{ top: displaySearch ? '50%' : '50%', transform: displaySearch ? 'translateY(-50%)' : 'translateY(-50%)' }"
            class="mobile-sidebar-toggle d-lg-none" type="button" data-bs-toggle="offcanvas"
            data-bs-target="#mobileSidebar" aria-controls="mobileSidebar" style="color: aliceblue;"
            [ngClass]="{ 'showButtonOnOverflowing': isMobileNavVisible, 'hideit': !isMobileNavVisible }">
            ☰
        </button>

        <div class="logo" [ngClass]="{ 'guest-logo': !loggedUser }">
            <img (click)="routeToHome()" src="assets/Images/Logo-img.png" alt="Bahamas Logo" class="logo-img"
                loading="eager" fetchpriority="high">
        </div>

        <div class="right-header">
            <ng-container *ngIf="loggedUser; else guestHeader">
                <span class="search-box">
                    <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
                        (keyup)="searchPrediction($event)" (paste)="preventPaste($event)" (copy)="preventCopy($event)"
                        (cut)="preventCut($event)" (contextmenu)="preventContext($event)" (drop)="preventDrop($event)">
                    <span *ngIf="showInput; else hideInput">
                        <mat-icon class="searchIcon" *ngIf="searchText; else elseBlock"
                            (click)="clearText()">close</mat-icon>
                        <ng-template #elseBlock>
                            <mat-icon class="searchIcon" (click)="search('main')">search</mat-icon>
                        </ng-template>
                    </span>
                    <ng-template #hideInput>
                        <mat-icon class="searchIcon" (click)="search('main')">search</mat-icon>
                    </ng-template>

                    <ng-container>
                        <div *ngIf="showDropdown && searchText" class="dropdown-menu search-dropdown">
                            <!-- Loading state -->
                            <span *ngIf="searchLoading; else searchResults">
                                <div class="dropdown-content loading-content">
                                    <i class="bi bi-arrow-clockwise"
                                        style="margin-right: 8px; animation: spin 1s linear infinite;"></i>
                                    <!-- <mat-icon style="margin-right: 8px; animation: spin 1s linear infinite;">refresh</mat-icon> -->
                                    Loading...
                                </div>
                            </span>

                            <!-- Search results -->
                            <ng-template #searchResults>
                                <span *ngIf="(filteredLabels.length>0 || filteredContent.length>0); else elseBlock">
                                    <div class="viewAll">
                                        <div>
                                            <a (click)="routeToSearch()">View All Results</a> >
                                        </div>
                                    </div>
                                    <div class="dropdown-content">
                                        <div *ngIf="filteredLabels.length>0">
                                            <ul class="filter-label">
                                                <li class="filter-li" *ngFor="let item of filteredLabels">
                                                    <a [routerLink]="[item.route]" (click)="onDropdownLinkNavigate()">
                                                        <span [innerHTML]="item.label | highlight: searchInput"></span>
                                                        of
                                                        <span
                                                            [innerHTML]="item.label_route | highlight: searchInput"></span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <hr>
                                        </div>
                                        <div *ngIf="filteredContent.length>0">
                                            <p class="website-result">Results from this website</p>
                                            <ul>
                                                <li *ngFor="let item of filteredContent">
                                                    <p style="color:grey; margin:1% 0"><i class="bi bi-info-circle"
                                                            style="margin-right: 3px;"></i>
                                                        <span class="match-type">{{ item.type ? (item.type | titlecase)
                                                            :
                                                            'Information' }}</span>
                                                    </p>
                                                    <a [attr.href]="resultHref(item)"
                                                        (click)="goToSearchResult(item, $event)"
                                                        [innerHTML]="item.match | highlight: searchInput"></a>
                                                    <hr>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </span>
                                <ng-template #elseBlock>
                                    <div class="dropdown-content no-search-content"><i class="bi bi-info-circle"
                                            style="margin-right: 3px;"></i> No Results Found</div>
                                </ng-template>
                            </ng-template>
                        </div>
                    </ng-container>
                </span>


                <!-- Session Time -->
                <div class="session-timer" *ngIf="loggedUser">
                    <p>
                        <span class="session-timer-text">Session Timer:</span>
                        <span id="session-timer-count"> {{ countdown }}</span>
                    </p>
                </div>

                <!-- Accessibility -->
                <span class="access" *ngIf="!isPhoneView" (click)="openAccessibility()"><mat-icon
                        class="spaceAfterIcon accessIcon">settings</mat-icon>
                    <span class="access-key textHover access-text"> Accessibility
                        Options</span></span>

                <!-- Notification Bell -->

                <!-- <div class="notification-bell">
                <mat-icon>notifications</mat-icon>
                </div> -->

                <!-- User Profile -->
                <!-- App Switcher -->
                <!-- <div class="app-switcher" (click)="toggleAppPanel($event)">
                    <button class="app-btn" [attr.aria-expanded]="isAppPanelVisible" aria-haspopup="true" type="button">
                        <mat-icon>apps</mat-icon>
                    </button>
                    <div class="apps-panel" *ngIf="isAppPanelVisible" (click)="$event.stopPropagation()">
                        <p>Switch to different apps</p>
                        <div class="apps-grid">
                            

                            <a class="app-item" *ngFor="let app of apps" (click)="openApp(app, $event)"
                                [attr.title]="app.label">

                                <span class="app-icon">
                                    <ng-container *ngIf="app.type === 'img'">
                                        <img [src]="app.icon" [alt]="app.label" />
                                    </ng-container>

                                    <ng-container *ngIf="!app.type || app.type === 'mat'">
                                        <mat-icon class="app-mat-icon"
                                            [fontSet]="app.fontSet || 'material-icons-outlined'">
                                            {{ app.icon }}
                                        </mat-icon>
                                    </ng-container>
                                </span>

                                <span class="app-label">{{ app.label }}</span>
                            </a>
                        </div>
                    </div>
                </div>  -->
                <div class="profile-box" [class.active-profile]="isDropdownVisible" (click)="toggleDropdown()">
                    <div class="prof-content">
                        <p>{{ profileConfig.user.name }}</p>
                        <p><span class="long-bin">{{ maskBinNumber(profileConfig.user.id) }}</span> <span
                                class="short-bin">{{
                                profileConfig.user.tin }}</span></p>
                        <span id="business-profile">{{ profileConfig.user.profile}}</span>
                    </div>
                    <div class="prof-icon">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </div>
                    <div class="prof-img">
                        <img [src]="avatarObjUrl || profileConfig?.user?.avatar || './assets/Images/default-avatar.png'"
                            [alt]="profileConfig?.user?.name || 'User avatar'" class="avatar-image"
                            (error)="onAvatarError($event)" (load)="onAvatarLoad($event)" />
                    </div>
                    <div class="dropdown-section" *ngIf="isDropdownVisible">
                        <div class="mobile-profile-summary" *ngIf="isPhoneView && profileConfig?.user">
                            <div class="mobile-profile-details">
                                <p class="mobile-profile-name">{{ profileConfig.user.name }}</p>
                                <p class="mobile-profile-bin">BIN <span>{{ maskBinNumber(profileConfig.user.id)
                                        }}</span></p>
                                <p class="mobile-profile-type">{{ profileConfig.user.profile }}</p>
                            </div>
                        </div>
                        <ng-container *ngIf="isPhoneView; else desktopProfileActions">
                            <button class="dropdown-item mobile-profile-action mobile-accessibility-action"
                                type="button" (click)="openMobileAccessibility($event)">
                                <mat-icon>settings</mat-icon>
                                <span>Accessibility</span>
                            </button>
                            <button class="dropdown-item mobile-profile-action" type="button"
                                (click)="routeToPage('/account/profile')">
                                <mat-icon>people</mat-icon>
                                <span>Manage Account</span>
                            </button>
                            <button class="dropdown-item mobile-profile-action" type="button"
                                (click)="routeToPage('/')">
                                <mat-icon>logout</mat-icon>
                                <span>Log Out</span>
                            </button>
                        </ng-container>
                        <ng-template #desktopProfileActions>
                            <div class="dropdown-item" (click)="routeToPage('/account/profile')">Manage Account</div>
                            <div class="dropdown-item" (click)="routeToPage('/')">Log Out</div>
                        </ng-template>
                    </div>
                </div>

            </ng-container>

            <!-- Guest Header -->
            <ng-template #guestHeader>
                <div class="access" (click)="openAccessibility()">
                    <mat-icon class="spaceAfterIcon accessIcon">settings</mat-icon>
                    <span class="access-keys textHover">Accessibility Options</span>
                </div>
                <!-- Language Selection -->
                <span class="lang">
                    <div style="display: flex;align-items: center;justify-content: center;gap: 1.5rem;">
                        <mat-icon class="langIcon">public</mat-icon>
                    </div>
                    <p class="fullText">English</p>
                    <span class="langText textHover shortText">EN</span>
                    <!-- <mat-icon>keyboard_arrow_down</mat-icon> -->
                </span>
            </ng-template>
        </div>

    </div>
    <div class="accessibility-section" *ngIf="viewAccessibility" (click)="stopEvent($event)">
        <app-accessibilty (fontSizeChanged)="checkNavbarOverflow()" (closeAccessibility)="hideAccessibility()"
            (click)="stopEvent($event)"></app-accessibilty>
    </div>

    <div class="menu" *ngIf="loggedUser" [ngClass]="{ 'menu-hide': isMobileNavVisible, '': !isMobileNavVisible }">
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul id="menuList" class="navbar-nav" *ngFor="let navValue of headerValues; let i=index">
                    <li class="nav-item" [ngClass]="{ selected: isRouteSelected(navValue.route) }"
                        (click)="routeToPage(navValue.route); closeNavbarCollapse()">
                        <a class="nav-link" (click)="routeToPage(navValue.route); closeNavbarCollapse()" role="button"
                            aria-expanded="false" [ngClass]="getNavbarFontSize()">
                            {{navValue.label}}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>

    <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileSidebar" aria-labelledby="mobileSidebarLabel">
        <div class="offcanvas-header">
            <p class="side-menu-text">Menu</p>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <ul class="list-unstyled">
                <li *ngFor="let navValue of headerValues; let i = index"
                    [ngClass]="{ selected: isRouteSelected(navValue.route) }">
                    <a class="nav-link w-100 text-start" [routerLink]="[navValue.route]"
                        (click)="closeNavbarCollapse()">{{ navValue.label }}</a>
                </li>
            </ul>
        </div>
    </div>

</header>

<div *ngIf="displaySearch" class="mobileSearch">
    <span class="">
        <input type="text" class="search" [(ngModel)]="searchText" placeholder="Search"
            (keyup)="searchPrediction($event)" (paste)="preventPaste($event)" (copy)="preventCopy($event)"
            (cut)="preventCut($event)" (contextmenu)="preventContext($event)" (drop)="preventDrop($event)">
        <mat-icon class="searchIcon mobile-icon" *ngIf="searchText; else elseBlockMobile"
            (click)="clearText()">close</mat-icon>
        <ng-template #elseBlockMobile>
            <mat-icon class="searchIcon mobile-icon" (click)="search('sub')">search</mat-icon>
        </ng-template>

    </span>
    <mat-icon class="searchIcon closeSearchIcon mobile-icon" (click)="closeMobileSearch()">close</mat-icon>
</div>
